import { getApiClient } from '../axios-config';

/**
 * Trades API Service
 * Handles all API calls related to trades
 */
class TradesAPI {
  /**
   * Get all trades
   * @param {string} token - JWT authentication token
   * @returns {Promise<Array>} Array of trade objects
   */
  static async getAll(token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get('/api/trades');
    // Handle response format - trades can be in data.data.trades or data.trades
    return response.data?.data?.trades || response.data?.trades || [];
  }

  /**
   * Get activities for a specific trade
   * @param {string} tradeId - Trade ID
   * @param {string} token - JWT authentication token
   * @returns {Promise<Array>} Array of activity objects
   */
  static async getActivitiesByTradeId(tradeId, token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get(`/api/trades/${tradeId}/activities`);
    return response.data?.data?.activities || [];
  }
}

export default TradesAPI;
